import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiGetComments(postId) {
    const res = await fetch(`${API_URL}/posts/${postId}/comments`);
    return res.json();
}

export async function apiCreateComment(postId, content, isAnonymous, realName) {
    const res = await fetch(`${API_URL}/posts/${postId}/comments`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({content, is_anonymous: isAnonymous, real_name: realName})
    });
    return res.json();
}

export async function apiDeleteComment(commentId) {
    const res = await fetch(`${API_URL}/comments/${commentId}`, {
        method: "DELETE",
        headers: authHeaders()
    });
    return res.json();
}
